module.exports = __webpack_public_path__ + "img/1-16.3a493b0b.png";